module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [(!_vm.form.card_id) ? _c('div', {
    staticClass: "content-center content-bottom-padded"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.form.card_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "card_type", $$v)
      },
      expression: "form.card_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "discount"
    }
  }, [_vm._v("折扣券")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "cash"
    }
  }, [_vm._v("代金券")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "gift"
    }
  }, [_vm._v("兑换券")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "service"
    }
  }, [_vm._v("服务券")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "free_shipping"
    }
  }, [_vm._v("免邮券")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "never",
      "header": "基础信息"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "37px",
      "color": "red"
    }
  }, [_vm._v("备注：修改过后用户已经领取过的优惠券将清空，包含已经使用过的优惠券")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠基准",
      "prop": "discount_again"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.discount_again),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount_again", $$v)
      },
      expression: "form.discount_again"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("零售价")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("折扣价")])], 1)], 1), _vm._v(" "), (_vm.form.card_type === 'gift') ? _c('el-form-item', {
    attrs: {
      "label": "兑换商品名称",
      "prop": "gift"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "maxlength": 20,
      "placeholder": "兑换商品名称"
    },
    on: {
      "change": _vm.giftChange
    },
    model: {
      value: (_vm.form.gift),
      callback: function($$v) {
        _vm.$set(_vm.form, "gift", $$v)
      },
      expression: "form.gift"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.inputValue.gift_length) + "/" + _vm._s(_vm.inputValue.gift_max))])], 1) : _vm._e(), _vm._v(" "), (_vm.form.card_type === 'discount') ? _c('el-form-item', {
    attrs: {
      "label": "折扣额度",
      "prop": "discount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "只能是大于等于1,小于10的数字",
      "max": "9.9",
      "min": "1"
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount", $$v)
      },
      expression: "form.discount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.card_type === 'cash') ? _c('el-form-item', {
    attrs: {
      "label": "减免金额",
      "prop": "reduce_cost"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "只能是大于0的数字"
    },
    model: {
      value: (_vm.form.reduce_cost),
      callback: function($$v) {
        _vm.$set(_vm.form, "reduce_cost", $$v)
      },
      expression: "form.reduce_cost"
    }
  }), _vm._v(" 元\n      ")], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发放数量",
      "prop": "quantity"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "text",
      "oninput": "value=value.replace(/[^\\d.]/g,'')",
      "placeholder": "只能是大于0的数字"
    },
    model: {
      value: (_vm.form.quantity),
      callback: function($$v) {
        _vm.$set(_vm.form, "quantity", _vm._n($$v))
      },
      expression: "form.quantity"
    }
  }), _vm._v(" 份\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "卡券标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "字数上限为30个汉字"
    },
    on: {
      "change": _vm.titleChange
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  }), _vm._v(" \n         "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.inputValue.title_length) + "/" + _vm._s(_vm.inputValue.title_max))]), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("建议填写代金券“减免金额”及自定义内容，描述卡券提供的具体优惠")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "精简标题",
      "prop": "str_title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "字数上限为30个汉字"
    },
    on: {
      "change": _vm.strTitleChange
    },
    model: {
      value: (_vm.form.str_title),
      callback: function($$v) {
        _vm.$set(_vm.form, "str_title", $$v)
      },
      expression: "form.str_title"
    }
  }), _vm._v(" \n         "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.inputValue.str_title_length) + "/" + _vm._s(_vm.inputValue.str_title_max))]), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("建议根据标题精简优惠券提示")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择分类"
    },
    on: {
      "change": _vm.handleCateChange
    },
    model: {
      value: (_vm.form.cate_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "cate_id", $$v)
      },
      expression: "form.cate_id"
    }
  }, _vm._l((_vm.category), function(item) {
    return _c('el-option', {
      key: _vm.form.cate_id ? _vm.form.cate_id : item.cate_id,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.cate_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "长合约"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "是否长合约"
    },
    on: {
      "change": _vm.handlelongCateChange
    },
    model: {
      value: (_vm.form.is_long),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_long", $$v)
      },
      expression: "form.is_long"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "否",
      "size": "mini",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "size": "mini",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用条件",
      "prop": "useCondition"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.conditionChange
    },
    model: {
      value: (_vm.form.useCondition),
      callback: function($$v) {
        _vm.$set(_vm.form, "useCondition", $$v)
      },
      expression: "form.useCondition"
    }
  }, [
    [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("不限制")])], _vm._v(" "), [_c('el-radio', {
      attrs: {
        "label": 2
      }
    }, [_vm._v("满  "), _c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      model: {
        value: (_vm.form.least_cost),
        callback: function($$v) {
          _vm.$set(_vm.form, "least_cost", $$v)
        },
        expression: "form.least_cost"
      }
    }), _vm._v("  元可用  \n              "), [_vm._v(" 最高限额 "), _c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      model: {
        value: (_vm.form.most_cost),
        callback: function($$v) {
          _vm.$set(_vm.form, "most_cost", $$v)
        },
        expression: "form.most_cost"
      }
    }), _vm._v("  元")], _vm._v(" "), [_vm._v(" 每个商品最低购买 "), _c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      model: {
        value: (_vm.form.min_buy_num),
        callback: function($$v) {
          _vm.$set(_vm.form, "min_buy_num", $$v)
        },
        expression: "form.min_buy_num"
      }
    }), _vm._v("  个可用")]], 2)]
  ], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期",
      "prop": "date_type"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeDatetime
    },
    model: {
      value: (_vm.form.date_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_type", $$v)
      },
      expression: "form.date_type"
    }
  }, [(!_vm.form.card_id || _vm.form.card_id && _vm.form.date_type === 'DATE_TYPE_FIX_TIME_RANGE') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "DATE_TYPE_FIX_TIME_RANGE"
    }
  }, [_vm._v("固定日期")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "380px"
    },
    attrs: {
      "type": "datetimerange",
      "value-format": "timestamp",
      "default-time": ['00:00:00', '23:59:59'],
      "picker-options": _vm.form.card_id ? '' : _vm.pickerOptions
    },
    model: {
      value: (_vm.date_range),
      callback: function($$v) {
        _vm.date_range = $$v
      },
      expression: "date_range"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.form.card_id || _vm.form.card_id && _vm.form.date_type === 'DATE_TYPE_FIX_TERM') ? _c('div', [_c('el-radio', {
    attrs: {
      "label": "DATE_TYPE_FIX_TERM"
    }
  }, [_vm._v("领取后, \n            "), _c('el-select', {
    attrs: {
      "size": "5"
    },
    model: {
      value: (_vm.form.begin_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "begin_time", $$v)
      },
      expression: "form.begin_time"
    }
  }, _vm._l((_vm.totalDays), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" 生效，有效天数 \n            "), _c('el-select', {
    attrs: {
      "size": "5"
    },
    model: {
      value: (_vm.form.days),
      callback: function($$v) {
        _vm.$set(_vm.form, "days", $$v)
      },
      expression: "form.days"
    }
  }, _vm._l((_vm.remainDays), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v("\n            统一过期时间 "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "timestamp",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.end_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_time", $$v)
      },
      expression: "form.end_time"
    }
  })], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "卡券使用说明",
      "prop": "description"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "textarea",
      "rows": 6,
      "resize": "none",
      "placeholder": "请填写使用本优惠券的注意事项"
    },
    on: {
      "change": _vm.descriptionChange
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.inputValue.description_length) + "/" + _vm._s(_vm.inputValue.description_max))])], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "never",
      "header": "适用规则"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "前台直接领取"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#d2d4db"
    },
    model: {
      value: (_vm.form.receive),
      callback: function($$v) {
        _vm.$set(_vm.form, "receive", $$v)
      },
      expression: "form.receive"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "扫码领取"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#d2d4db"
    },
    model: {
      value: (_vm.form.can_qrcode_flag),
      callback: function($$v) {
        _vm.$set(_vm.form, "can_qrcode_flag", $$v)
      },
      expression: "form.can_qrcode_flag"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("勾选扫码领取前，关闭前台可领。只能通过扫码领不再优惠券列表展示")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "领券限制"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.form.get_limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "get_limit", $$v)
      },
      expression: "form.get_limit"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("每个用户领券上限，如不填，则默认为1")])], 1), _vm._v(" "), (_vm.is_distributor == false || _vm.form.card_type != 'gift') ? _c('el-form-item', {
    attrs: {
      "label": "适用平台"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.form.card_id != ''
    },
    on: {
      "change": _vm.usePlatformChange
    },
    model: {
      value: (_vm.form.use_platform),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_platform", $$v)
      },
      expression: "form.use_platform"
    }
  }, [(_vm.is_distributor == false) ? _c('el-radio', {
    attrs: {
      "label": "store"
    }
  }, [_vm._v("门店专用")]) : _vm._e(), _vm._v(" "), (_vm.form.card_type != 'gift') ? _c('el-radio', {
    attrs: {
      "label": "mall"
    }
  }, [_vm._v("线上商城专用")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.is_distributor == false) ? _c('el-form-item', {
    attrs: {
      "label": "核销场景",
      "prop": "use_scenes"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.form.card_id != ''
    },
    model: {
      value: (_vm.form.use_scenes),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_scenes", $$v)
      },
      expression: "form.use_scenes"
    }
  }, [(_vm.form.card_type != 'gift' && _vm.form.use_platform == 'mall') ? _c('el-radio', {
    attrs: {
      "label": "ONLINE"
    }
  }, [_vm._v("线上商城使用")]) : _vm._e(), _vm._v(" "), (_vm.form.card_type != 'gift' && _vm.form.use_platform == 'store') ? _c('el-radio', {
    attrs: {
      "label": "QUICK"
    }
  }, [_vm._v("快捷买单使用")]) : _vm._e(), _vm._v(" "), (_vm.form.use_platform == 'store') ? _c('el-radio', {
    attrs: {
      "label": "SELF"
    }
  }, [_vm._v("自助核销（到店使用）")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用限制",
      "prop": "merchant_isuse"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.merchant_isuse),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchant_isuse", $$v)
      },
      expression: "form.merchant_isuse"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("怡康自营")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("第三方商家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("全平台可使用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "费用承担",
      "prop": "merchant_iscost"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.merchant_iscost),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchant_iscost", $$v)
      },
      expression: "form.merchant_iscost"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("怡康自营")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("第三方商家")])], 1), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("若为第三方商家优惠券,请谨慎选择此项")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否可叠加",
      "prop": "is_add"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_add),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_add", $$v)
      },
      expression: "form.is_add"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不可叠加")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("可叠加")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用途类型",
      "prop": "use_type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.use_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_type", $$v)
      },
      expression: "form.use_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("普通优惠券")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("红包券")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": "true"
    }
  }, [_vm._v("运费券(暂时不开发)")]), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("普通优惠券之间不可叠加"), _c('br'), _vm._v("红包券最多和一张普通优惠券叠加"), _c('br'), _vm._v("运费券仅参与运费优惠")])], 1)], 1), _vm._v(" "), (_vm.form.use_scenes == 'SELF') ? _c('el-form-item', {
    attrs: {
      "label": "验证码"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.form.card_id != ''
    },
    model: {
      value: (_vm.self_rcode),
      callback: function($$v) {
        _vm.self_rcode = $$v
      },
      expression: "self_rcode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("启用验证码")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("不启用验证码")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.self_rcode === '1') ? _c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "maxlength": "4",
      "minlength": "4"
    },
    model: {
      value: (_vm.form.self_consume_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "self_consume_code", $$v)
      },
      expression: "form.self_consume_code"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.form.use_platform == 'mall' && _vm.form.card_type != 'gift') ? _c('el-card', {
    attrs: {
      "header": "商品",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用商品"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.itemTypeChange
    },
    model: {
      value: (_vm.form.use_all_items),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_all_items", $$v)
      },
      expression: "form.use_all_items"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全部商品适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("指定商品适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "other"
    }
  }, [_vm._v("指定商品不可用")])], 1)], 1), _vm._v(" "), (!_vm.zdItemHidden) ? _c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_distributor == false && _vm.form.use_platform == 'store') ? _c('el-card', {
    attrs: {
      "header": "门店",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用门店"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.shopTypeChange
    },
    model: {
      value: (_vm.form.use_all_shops),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_all_shops", $$v)
      },
      expression: "form.use_all_shops"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全部门店适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("指定门店适用")])], 1)], 1), _vm._v(" "), (!_vm.zdShopHidden) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addStoreAction
    }
  }, [_vm._v("选择店铺")]), _vm._v(" "), (_vm.distributor_info.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.distributor_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "wxShopId",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "storeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index)
            }
          }
        })]
      }
    }], null, false, 4185408658)
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_distributor == false && _vm.form.use_platform == 'mall') ? _c('el-card', {
    attrs: {
      "header": "店铺",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用店铺"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.shopTypeChange
    },
    model: {
      value: (_vm.form.use_all_shops),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_all_shops", $$v)
      },
      expression: "form.use_all_shops"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全部适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("指定店铺适用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "以下店铺不可用"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.choseDistributorNo
    },
    model: {
      value: (_vm.form.distributor_id_noflag),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor_id_noflag", $$v)
      },
      expression: "form.distributor_id_noflag"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("怡康自营选中店铺不可用")])], 1)], 1), _vm._v(" "), (!_vm.zdShopHidden) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDistributorAction
    }
  }, [_vm._v("选择店铺")]), _vm._v(" "), (_vm.distributor_info.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.distributor_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteDistritutorRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 3521329561)
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('form')
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('StoreSelect', {
    attrs: {
      "store-visible": _vm.storeVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relShopIds,
      "get-status": _vm.setStatus
    },
    on: {
      "chooseStore": _vm.chooseStoreAction,
      "closeStoreDialog": _vm.closeStoreDialogAction
    }
  }), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.distributorVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relDistributorIds,
      "get-status": _vm.setDistributorStatus
    },
    on: {
      "chooseStore": _vm.chooseDistributorAction,
      "closeStoreDialog": _vm.closeDistributorDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e9b2b1b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e9b2b1b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/edit.vue
// module id = 2652
// module chunks = 0